import * as React from 'react'
// Reactstrap
import { Row as LibRow } from 'reactstrap'
// Styles
import './Row.scss'

class Row extends React.PureComponent {
  render() {
    const className =
      'Row' +
      (this.props.className ? ' ' + this.props.className : ' ') +
      (this.props.grid ? ' grid' : '') +
      (this.props.flexFit ? ' flex-fit' : '') +
      (this.props.flexWrap ? ' flex-' + this.props.flexWrap : '') +
      (this.props.flexDirection ? ' flex-' + this.props.flexDirection : '') +
      (this.props.justifyContent ? ' justify-content-' + this.props.justifyContent : '') +
      (this.props.gutters ? ' gutters-' + this.props.gutters : '') +
      (this.props.alignItems ? ' align-items-' + this.props.alignItems : '')
    return (
      <LibRow style={this.props.style} className={className}>
        {this.props.children}
      </LibRow>
    )
  }
}

export default Row
